import { useTranslation } from 'react-i18next';
import { Private } from '@shared/components/common/Private';

interface GuestDetailsCardProps {
  name: string;
  email?: string;
  phone?: string;
  showAgentNote?: boolean;
  className?: string;
}

export function GuestDetailsCard({ name, email, phone, showAgentNote, className }: GuestDetailsCardProps) {
  const { t } = useTranslation('booking');

  if (!name) return null;

  return (
    // Agent-reservation guest info is PII rendered as display text.
    // Wrap so session-replay tools don't capture the values when this card
    // shows on ConfirmationPage (or anywhere else GuestDetailsCard is used).
    <Private className={`bg-foreground/5 rounded-xl p-5 space-y-4 ${className ?? ''}`}>
      <h3 className="font-display text-lg font-semibold text-foreground">
        {t('AGENT_GUEST_DETAILS')}
      </h3>
      <Row label={t('AGENT_GUEST_NAME')} value={name} />
      {email && <Row label={t('AGENT_GUEST_EMAIL')} value={email} />}
      {phone && <Row label={t('AGENT_GUEST_PHONE')} value={phone} />}
      {showAgentNote && (
        <p className="text-xs text-foreground/50">
          {t('AGENT_GUARANTEE_WILL_BE_SENT')}
        </p>
      )}
    </Private>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex justify-between items-start">
      <span className="text-sm text-foreground/50">{label}</span>
      <span className="text-sm font-medium text-foreground text-right max-w-[60%]">{value}</span>
    </div>
  );
}
